export const theme = {
  colors: {
    bg: '#1F1F1F',
    bg1: '#282B2C',
    bg2: '#3A3E3F',
    bg3: '#6D7174',
    fgPrimary: '#FFFFFF',
    fgMuted: '#DDDDE9',
    fgMuted2: '#CACACA',
    green: '#5EFFA8',
  },
  borderRadius: '4px',
  fonts: {
    mono: `'IBM Plex Mono', 'Inconsolata', monospace`,
  },
  spacing: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
  },
};
